<div class="ion-padding">
  No hay mensajes nuevos.
</div>